<div class="report-page">
  <header *ngIf="showHeader" class="report-header">
    <button type="button" class="back-link" (click)="backToGallery()">
      <ng-container *ngIf="backMode === 'moduleDashboard'; else directBack">
        &larr; Back to {{ moduleName }}
      </ng-container>
      <ng-template #directBack>&larr; Back to Reports</ng-template>
    </button>
    <h1>{{ reportName }}</h1>
  </header>

  <div *ngIf="!showHeader && backMode === 'moduleDashboard'" class="report-toolbar">
    <button type="button" class="back-link" (click)="backToGallery()">
      &larr; Back to {{ moduleName }}
    </button>
  </div>

  <div *ngIf="errorMessage" class="report-error" role="alert">
    <p>{{ errorMessage }}</p>
    <button type="button" (click)="retry()">Retry</button>
  </div>

  <div *ngIf="loadingReport && !errorMessage" class="report-loading">
    Loading report...
  </div>

  <div
    #reportContainer
    class="report-container"
    [class.report-container--embedded]="!showHeader"
    [class.report-container--hidden]="loadingReport || errorMessage"
  ></div>
</div>
